import { z } from 'zod'

import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

const Schema = z.object({
  data: z.object({
    marked_by_id: z.string().nullable(),
    unavailability_reason_id: z.number().nullable(),
    unavailability_remark: z.string().nullable(),
    unavailable_till: z.string().nullable(),
    unavailability_reason_key: z.string().nullable()
  })
})

export type UnavailabilitySchedule = z.infer<typeof Schema>

const getUnavailabilitySchedule = async (
  userId: string
): Promise<ApiResponseV2<UnavailabilitySchedule>> => {
  try {
    z.string().parse(userId)

    const endpoint = `/users/${userId}/unavailability-schedule`
    const response = await axios.get<UnavailabilitySchedule>(endpoint)

    Schema.parse(response.data)

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export default getUnavailabilitySchedule
